<script lang="ts">

    import { Table } from "sveltestrap";
    import type { Answer, QuestionGridColumnType } from "../../global";
    import type { GridColumn } from "../../Model/GridColumn";
    import type { GridRow } from "../../Model/GridRow";
    import type { Question } from "../../Model/Question";
    import DateString from "../DateString.svelte";
    import Watch from "../Watch.svelte";

    export let question: Question;
    export let answer: Answer;

    const grid = question.options.questionGrid;
    const defaultValues: Record<QuestionGridColumnType, any> = {
        text    : '',
        amount  : 0,
        check   : false,
        date    : ''
    };

    function getValue(row: GridRow, column: GridColumn): any {
        if (!Array.isArray(answer.value)) {
            return defaultValues[column.type.value];
        }
        const value = answer.value.find(({ cid, rid }) => column.id === cid && row.id === rid);
        if (value) {
            return value.val;
        }
        return defaultValues[column.type.value];
    }

</script>

<h6>
    <Watch store={question.name} />
</h6>

<Table>
    <thead>
        <tr>
            <th></th>
            <Watch store={grid.columns} let:value={columns}>
                {#each columns as column}
                    <th><Watch store={column.name} /></th>
                {/each}
            </Watch>
        </tr>
    </thead>
    <tbody>
        <Watch store={grid.rows} let:value={rows}>
            {#each rows as row}
                <tr>
                    <td><Watch store={row.text} /></td>
                    <Watch store={grid.columns} let:value={columns}>
                        {#each columns as column}
                        <td>
                            {#if column.type.value === 'date'}
                                <DateString date={getValue(row, column)} />
                            {:else if column.type.value === 'check'}
                                {getValue(row, column) ? 'Sí' : 'No'}
                            {:else if ['text', 'amount'].includes(column.type.value)}
                                {getValue(row, column)}
                            {/if}    
                        </td>
                        {/each}
                    </Watch>
                </tr>
            {/each}
        </Watch>
    </tbody>
</Table>